package com.downdogapp.client.controllers

import com.downdogapp.client.ViewController
import com.downdogapp.client.singleton.Key
import com.downdogapp.client.singleton.UserPrefs
import com.downdogapp.client.views.HealthWaiverView

class HealthWaiverViewController(private val callback: () -> Unit) : ViewController() {

  override val view = HealthWaiverView(this)

  fun onAgreeClicked() {
    UserPrefs[Key.AcceptedHealthWaiver] = true
    onBackClicked()
  }

  override fun onPopped() {
    callback()
  }

  companion object {

    val acceptedHealthWaiver get() = UserPrefs[Key.AcceptedHealthWaiver] == true
  }
}
